import { render } from "./registerExpense.vue?vue&type=template&id=78c087e6&scoped=true"
import script from "./registerExpense.vue?vue&type=script&lang=js"
export * from "./registerExpense.vue?vue&type=script&lang=js"

import "./registerExpense.vue?vue&type=style&index=0&id=78c087e6&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/gafwa_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78c087e6"]])

export default __exports__